import { openDB, IDBPDatabase } from 'idb';

const DB_NAME = 'PsycoDB';
const RESULTS_LOCAL_STORE = 'results';

export class IndexedDBService {
  static async getDB(): Promise<IDBPDatabase> {
    return openDB(DB_NAME, 1, {
      upgrade(db) {
        if (!db.objectStoreNames.contains(RESULTS_LOCAL_STORE)) {
          db.createObjectStore(RESULTS_LOCAL_STORE, { keyPath: 'id' });
        }
      },
    });
  }

  static async put<T = any>(store: string, value: T): Promise<void> {
    const db = await this.getDB();
    await db.put(store, value);
  }

  static async get<T = any>(store: string, id: string): Promise<T | undefined> {
    const db = await this.getDB();
    return db.get(store, id);
  }

  static async delete(store: string, id: string): Promise<void> {
    const db = await this.getDB();
    await db.delete(store, id);
  }

  static async clear(store: string): Promise<void> {
    const db = await this.getDB();
    await db.clear(store);
  }
} 